import { IInspectContainerFormData } from '@planning/pages/TallymanV2/Components/InspectContainer/InspectContainerForm'
import { CargoData, CreateOverlandedContainerVisitCommand } from '@planning/app/api'

const mapToInboundCargoData = (data: IInspectContainerFormData): CargoData => {
  return {
    imoClasses: [],
    isOOG: data?.oog?.isOog,
    overHeight: data?.oog?.overHeight,
    overLengthFront: data?.oog?.overLengthFront,
    overLengthRear: data?.oog?.overLengthRear,
    overWidthLeft: data?.oog?.overWidthLeft,
    overWidthRight: data?.oog?.overWidthRight,
    unloadingMethod: data?.oog?.unloadingMethod ?? undefined,
    isEmpty: data?.isEmpty,
    grossWeight: data?.grossWeight,
    vgm: data?.vgm,
    unitLabel: data?.unitLabel,
  }
}

export const mapFormDataToOverlandedContainerVisitCommand = (
  data: IInspectContainerFormData,
): CreateOverlandedContainerVisitCommand => {
  return {
    containerNumber: data?.containerNumber ?? '',
    containerIsoCode: data?.containerIsoCode ?? '',
    containerMaxGross: data?.containerMaxGross,
    containerTare: data?.containerTare,
    isOverlanded: true,
    inboundCargo: mapToInboundCargoData(data),
    inboundTransportData: {
      carrierType: data?.carrierType ?? '',
      carrierVisitId: data?.carrierVisitId,
    },
    notes: data.notes,
    inboundHasSeals: data.hasSeals,
    inboundSeals: data.seals ?? [],
  }
}
